import React, { useEffect, useState } from "react";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import BaseCustomerTable from "../BaseCustomerTable/BaseCustomerTable";
import DynamicTable from "../DynamicTable/DynamicTable";
import { Box, IconButton } from "@mui/material";
import { CSVLink } from "react-csv";
import pdfImage from "../../images/pdf-image.svg"
import csvImage from "../../images/excel-image.svg"
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export default function OFACReportTable({
  ofacData,
  handleSelectedUser,
  targetID,
  systemRoles,
  ofacStatus,
  startDate,
  endDate
}) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const pageCount = Math.ceil(ofacData.length / rowsPerPage);
  const pageNumbers = Array.from({ length: pageCount }, (_, index) => index);
  const [usersTable, setUsersTable] = useState(null);
  const [filteredRecords, setFilteredRecords] = useState([]);

  // console.log(pageCount, pageNumbers)

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // console.log(ofacData)

  async function getTable() {
    let response = await fetch(`/tables/OFACReportTable.json`);
    // let response = await fetch(`/tables/operatorTable.json`);
    const tableData = await response.json();
    // console.log("tableData==========",tableData);
    // console.log("ofacData==========",ofacData);
    setUsersTable(tableData);
    setRowsPerPage(tableData.rowsPerPage);
  }

  useEffect(() => {
    getTable();
  }, []);

  const runPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4"
    });

    const formatDate = (dateStr) => new Date(dateStr).toISOString().slice(0, 10);
    const dateRange = `(${formatDate(startDate)} to ${formatDate(endDate)})`;
  
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    // doc.text("User OFAC Report", 14, 15);
    doc.text(`OFAC Report ${dateRange}`, 14, 15);
  
    // Define headers and body
    const headers = [
        "User Id",
        "Name",
        "Email",
        "KYC Policy Id",
        "OFAC Run Date",
        "OFAC Score",
        "Run By"
    ];
  
    const body = flatUsers.map(user => [
        user.userid,
        `${user.firstName ? user.firstName : "-"} ${user.lastName ? user.lastName : "-"}`,
        user.emailAccount,
        user.kycpolicyid,
        user.requesttime,
        user.score,
        `${user.runbyFirstName ? user.runbyFirstName : "-"} ${user.runbyLastName ? user.runbyLastName : "-"}`
    ]);
  
    // Call autoTable with the doc
    autoTable(doc, {
      head: [headers],
      body: body,
      startY: 20,
      theme: "striped",
      styles: {
        fontSize: 10,
        cellPadding: 3
      },
      headStyles: {
        fillColor: [108, 117, 125] // Bootstrap secondary gray
      }
    });
  
    doc.save(`OFAC-Report-${new Date().toISOString().slice(0, 10)}.pdf`);
  };

  const flatUsers = ofacData.map(user => user.UserOfac);
  const csvData = flatUsers.map(user => ({
    "User Id": user?.userid,
    "Name": `${user?.firstName} ${user?.lastName}`,
    "Email": user?.emailAccount,
    "KYC Policy Id": user?.kycpolicyid,
    "OFAC Run Date": user?.requesttime,
    "OFAC Score": user?.score == "-0" ? "0" : user?.score,
    "Run By": `${user.runbyFirstName ? user.runbyFirstName : "-"} ${user.runbyLastName ? user.runbyLastName : "-"}`
  }));

  return (
    <>
      <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
        <Box
          className="text-end"
          sx={{
            display: "flex",
            alignItems: "center",
            marginBottom: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "right",
              marginLeft: "auto",
            }}
          >
            <CSVLink
              data={csvData}
              filename={`PAiY-Test-${new Date().toISOString().slice(0, 10)}.csv`}
              style={{ textDecoration: "none" }}
            >
              <IconButton
                sx={{
                  width: 40,
                  height: 40,
                  color: "#6c757d",
                  backgroundColor: "transparent",
                  "&:hover": {
                    backgroundColor: "rgba(108, 117, 125, 0.1)",
                  },
                }}
              >
                <img src={csvImage} alt="CSV" loading="lazy" />
              </IconButton>
            </CSVLink>

            {/* PDF Button */}
            <IconButton
              onClick={runPDF}
              sx={{
                width: 40,
                height: 40,
                color: "#6c757d",
                backgroundColor: "transparent",
                "&:hover": {
                  backgroundColor: "rgba(108, 117, 125, 0.1)",
                },
              }}
            >
              <img src={pdfImage} alt="PDF" loading="lazy" />
            </IconButton>
          </Box>
        </Box>
        {usersTable && (
          <DynamicTable
            tableData={ofacData}
            tableSource={usersTable}
            page={page}
            handleEdit={handleSelectedUser}
            targetID={targetID}
            twoColumn={false}
            roles={systemRoles}
            ofacStatus={ofacStatus}
          />
        )}
        <BaseCustomerTable
          page={page}
          onPageChange={handleChangePage}
          pageNumbers={pageNumbers}
        />
      </TableContainer>
    </>
  );
}
